import { useState } from "react"
import SpecificFilter from "./SpecificFilter"
import PayerTypeStatusRepeater from "./PayerTypeStatusRepeater"
import PracticePatientStatusRepeater from "./PracticePatientStatusRepeater"

export default function MegaMasterFiltersItem({classes, item, mainSelectAction, generalAsyncSearchFilter, filtersValues, workQ, payerTypeStatusAction, removepayerTypeStatus, practicePatientStatusAction}) {
    const [isGroupOpened, setIsGroupOpened] = useState(false)

    function openGroupHandler() {
        setIsGroupOpened(prev => prev = !prev)
    }

    return <div key={item.group} className={classes.group}>
        <button onClick={openGroupHandler} className={`${classes.trigger} ${isGroupOpened ? classes.opened : ''}`}>
            {item.group}
            <i className="ti ti-chevron-down"></i>
        </button>
        {isGroupOpened && <>
            <div className={classes.drawer}>
                {item.group == 'Case' && <>
                    {item.filters && item.filters.filter(elem => elem.key != 'payer_type_filters' && elem.key != 'practice_patient_status_filters') && <div className={classes.drawer_inner}>
                        {item.filters.filter(elem => elem.key != 'payer_type_filters' && elem.key != 'practice_patient_status_filters').map(filter => (
                            <SpecificFilter key={filter.key} item={filter} mainSelectAction={mainSelectAction} generalAsyncSearchFilter={generalAsyncSearchFilter} filtersValues={filtersValues} workQ={workQ} />
                        ))}    
                    </div>}
                    {item.filters.filter(elem => elem.key == 'payer_type_filters').map(filter => (
                        <PayerTypeStatusRepeater key={filter.key} classes={classes} item={filter} mainSelectAction={payerTypeStatusAction} generalAsyncSearchFilter={generalAsyncSearchFilter} filtersValues={filtersValues} workQ={workQ} removepayerTypeStatus={removepayerTypeStatus}/>
                    ))} 
                    {item.filters.filter(elem => elem.key == 'practice_patient_status_filters').map(filter => (
                        <PracticePatientStatusRepeater key={filter.key} classes={classes} item={filter} mainSelectAction={practicePatientStatusAction} matchAction={mainSelectAction} filtersValues={filtersValues} workQ={workQ}/>
                    ))}
                </>}
                {item.group != 'Case' && <div className={classes.drawer_inner}>
                    {item.filters && item.filters.filter(elem => elem.key != 'practice_patient_status_filters').map(filter => (
                        <SpecificFilter
                            key={filter.key}
                            item={filter}
                            mainSelectAction={mainSelectAction}
                            generalAsyncSearchFilter={generalAsyncSearchFilter}
                            filtersValues={filtersValues}
                            workQ={workQ}
                        />
                    ))}
                </div>}
                {item.group != 'Case' && item.filters?.filter(elem => elem.key == 'practice_patient_status_filters').map(filter => (
                    <PracticePatientStatusRepeater key={filter.key} classes={classes} item={filter} mainSelectAction={practicePatientStatusAction} matchAction={mainSelectAction} filtersValues={filtersValues} workQ={workQ}/>
                ))}
               
            </div>
        </>}
    </div>
}